import React from "react";
import { Button } from 'primereact/button';


function RadioGroupBtn(props) {
    // console.log(props);
    let buttons = [];
    props.options.map(o => {
        if (props.optionLabel) {
            if (o[props.optionValue] === props.value[props.optionValue]) {
                buttons.push(<Button raised onClick={(e) => props.onChange(o)} severity="warning" className="p-button-sm text-xs mr-1  h-10">{o[props.optionLabel]}</Button>)
            }
            else {
                buttons.push(<Button raised onClick={(e) => props.onChange(o)} className=" p-button-sm text-xs mr-1 h-10">{o[props.optionLabel]}</Button>)
            }
        }
        else {
            if (o === props.value) {
                buttons.push(<Button raised onClick={(e) => props.onChange(o)} severity="warning" className="p-button-sm text-xs mr-1  h-10 ">{o}</Button>)
            }
            else {
                buttons.push(<Button raised onClick={(e) => props.onChange(o)} className=" p-button-sm text-xs mr-1 h-10">{o}</Button>)
            }
        }


    })
    return (

        <div className={props.className}>

            {buttons}

        </div>
    )

};


export default RadioGroupBtn;